(function() {

    'use strict';

    var equivalenceDesktopCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'equivalence-desktop.component.html',
        controller: equivalenceDesktopCtrl,
        bindings: {
            data: '<',
            translations: '<',
            centimeter: '<',
            sectionActive: '<',
            goToMeasureMyself: '&'
        }
    };

    equivalenceDesktopCtrl.$inject = [];

    function equivalenceDesktopCtrl() {

        var _this = this;
        var mySwiper;
        _this.toggleUnitOfmeasure = toggleUnitOfmeasure;
        _this.textPagination = setTextPagination();
        _this.highlightedCountry = highlightedCountry;
        
        _this.showInchesText = _this.centimeter;

        var sectionActive;
        setTimeout(function() {

            mySwiper = new Swiper('.swiper-sizes', {
                speed: 800,
                autoplay: false,
                effect: 'fade',
                loop: true,
                activeIndex: true,
                pagination: {
                    el: '.swiper-nav',
                    type: 'bullets',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<label class="' + className + '"><span>' + _this.textPagination[index] + '</span></label>';
                    }
                }
            });

            switch(_this.sectionActive) {
                case 'lower_part':
                    sectionActive = 2;
                    break;
                case 'footwear':
                    sectionActive = 4;
                    break;
                case 'accessory':
                    sectionActive = 3;
                    break;
                case 'extras':
                    sectionActive = 5;
                    break;
                default:
                    sectionActive = 1;
                    break;
            }
            
            mySwiper.slideTo(sectionActive, 200, false);

        }, 1);

        // SERVICE FUNCTIONS
        function setTextPagination() {
            var arrayName = [];
            _.each(_this.data, function (data) {
                arrayName.push( _this.translations[data.category + '_nav'] );
            });
            return arrayName;
        }

        function toggleUnitOfmeasure(measure) {
            if(measure === 'cm'){
                _this.centimeter = true;    
            } else {
                _this.centimeter = false;
            }
        }
        
        function highlightedCountry(key) {
            var arrayNotEurope = ['gb','us','me','cn','it','ko','ru'];
            if(key == 'eu' && arrayNotEurope.indexOf(inditex.iCountryCode.toLowerCase()) == -1) {
                return 'highlighted';
            }
            if(key == inditex.iCountryCode.toLowerCase()) {
                return 'highlighted';
            }
        }

    }

    angular.module('itxApp.common')
        .component('equivalenceDesktop', equivalenceDesktopCmp);

})();